__turbopack_context__.v({
  "ActionButton": "Autocomplete-module-scss-module__vzgbPG__ActionButton",
  "EndAdornment": "Autocomplete-module-scss-module__vzgbPG__EndAdornment",
  "Input": "Autocomplete-module-scss-module__vzgbPG__Input",
  "InputRoot": "Autocomplete-module-scss-module__vzgbPG__InputRoot",
  "InputRoot___readOnly": "Autocomplete-module-scss-module__vzgbPG__InputRoot___readOnly",
  "InputRoot___view": "Autocomplete-module-scss-module__vzgbPG__InputRoot___view",
  "TextFieldInputWrapper": "Autocomplete-module-scss-module__vzgbPG__TextFieldInputWrapper",
  "TextFieldWrapper": "Autocomplete-module-scss-module__vzgbPG__TextFieldWrapper",
});
